import React from 'react';
import Popover from 'material-ui/Popover';
import PropTypes from 'prop-types';
import moment from 'moment';
import IconButton from 'material-ui/IconButton';

import { DropTarget } from 'react-dnd';
import { TREATMENTINSTANCE } from '../TreatmentInstance/TreatmentInstance';
import { ASSIGNMENT } from '../TimelineAssignment/TimelineAssignment';
import globals from '../../../globals/communityGlobals';
import { cardTypes } from '../../../settings/constants/cardTypes';
import clinicianPropTypes from '../../../propTypes/entities/clinician';
import gradePropTypes from '../../../propTypes/entities/grade';
import timePropTypes from '../../../propTypes/entities/time';
import postcodeMileagesTypes from '../../../propTypes/entities/postcodeMileages';
import { parseDateUtc } from '../../../utils/dates';
import { appSettingsPropTypes } from '../../../propTypes/entities/appSettings';
import { RAGSTATUS_AMBER_FROMINTERVAL, RAGSTATUS_RED_FROMINTERVAL } from '../../../settings/constants/appSettings';

const locale = globals.getArea('dailyPlanning');
let item = null;

function createCSSSelector(selector, style) {
  let styleSheet;
  let mediaType;
  if (!document.styleSheets) return;
  if (document.getElementsByTagName('head').length === 0) return;

  if (document.styleSheets.length > 0) {
    for (let i = 0, l = document.styleSheets.length; i < l; i += 1) {
      if (document.styleSheets[i].disabled !== true) {
        const media = document.styleSheets[i].media;
        mediaType = typeof media;

        if (mediaType === 'string') {
          if (media === '' || media.indexOf('screen') !== -1) {
            styleSheet = document.styleSheets[i];
          }
        } else if (mediaType === 'object') {
          if (media.mediaText === '' || media.mediaText.indexOf('screen') !== -1) {
            styleSheet = document.styleSheets[i];
          }
        }

        if (typeof styleSheet !== 'undefined') {
          break;
        }
      }
    }
  }

  if (typeof styleSheet === 'undefined') {
    const styleSheetElement = document.createElement('style');
    styleSheetElement.type = 'text/css';
    document.getElementsByTagName('head')[0].appendChild(styleSheetElement);

    for (let i = 0; i < document.styleSheets.length; i += 1) {
      if (document.styleSheets[i].disabled !== true) {
        styleSheet = document.styleSheets[i];
      }
    }

    mediaType = typeof styleSheet.media;
  }

  if (mediaType === 'string') {
    for (let i = 0, l = styleSheet.rules.length; i < l; i += 1) {
      if (
        styleSheet.rules[i].selectorText &&
        styleSheet.rules[i].selectorText.toLowerCase() === selector.toLowerCase()
      ) {
        styleSheet.rules[i].style.cssText = style;
        return;
      }
    }
    styleSheet.addRule(selector, style);
  } else if (mediaType === 'object') {
    const styleSheetLength = styleSheet.cssRules ? styleSheet.cssRules.length : 0;
    for (let i = 0; i < styleSheetLength; i += 1) {
      if (
        styleSheet.cssRules[i].selectorText &&
        styleSheet.cssRules[i].selectorText.toLowerCase() === selector.toLowerCase()
      ) {
        styleSheet.cssRules[i].style.cssText = style;
        return;
      }
    }
    styleSheet.insertRule(`${selector}{${style}}`, styleSheetLength);
  }
}

const dropTarget = {
  canDrop(props, monitor) {
    item = monitor.getItem();
    const itemType = monitor.getItemType();

    if (itemType !== ASSIGNMENT && item.cardType !== cardTypes.MASTER && item.cardType !== cardTypes.REVIEW) {
      return false;
    }

    if (!props.clinician.canDoTreatments.includes(item.treatmentId)) {
      return false;
    }

    return true;
  },
};

function collect(connect, monitor) {
  return {
    canDrop: monitor.canDrop(),
  };
}

const printMsg = locale.getMsg('printPlan');
const hasSkills = locale.getMsg('hasSkills');
const styles = {
  statsPopoverContent: { padding: '10px' },
  workingTime: { marginBottom: '15px' },
  leftInfoBox: { display: 'flex', justifyContent: 'space-between' },
  anchorOrigin: { horizontal: 'middle', vertical: 'center' },
  targetOrigin: { horizontal: 'left', vertical: 'top' },
};

class ClinicianHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  shouldComponentUpdate = (nextProps, nextState) =>
    this.props.canDrop !== nextProps.canDrop ||
    this.props.offset !== nextProps.offset ||
    this.props.clinician !== nextProps.clinician ||
    this.props.assignedTime !== nextProps.assignedTime ||
    this.props.mapViewState !== nextProps.mapViewState ||
    this.props.selectedClinicianId !== nextProps.selectedClinicianId ||
    this.props.selectedDate !== nextProps.selectedDate ||
    this.props.postcodeDistance.postcode !== nextProps.postcodeDistance.postcode ||
    this.props.clinician.canDoTreatments.join(',') !== nextProps.clinician.canDoTreatments.join(',') ||
    this.state.isOpen !== nextState.isOpen;

  getViewStyles = () => ({
    display: this.props.mapViewState ? null : 'none',
    backgroundColor: `#${this.props.clinician.clinicianColor}`,
    width: '10px',
    height: '10px',
    orderRadius: '6px',
  });

  handleTouchTap = event => {
    event.preventDefault();
    event.stopPropagation();

    const { mapViewState, clinician } = this.props;
    if (mapViewState) {
      this.props.selectClinician(clinician.id);
    } else {
      this.setState({
        isOpen: true,
        anchorEl: event.currentTarget,
      });
    }
  };

  handleRequestClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  status = () => {
    const { status, offset, differentOrder, selectedDate } = this.props;
    if (!moment(selectedDate).isSame(globals.now.utcOffset(0, true), 'day')) {
      return '';
    }
    let label = '';
    let className = 'clinician-time';
    if (differentOrder) {
      label = locale.getMsg('differentOrder');
      className += ' different-order';
    } else {
      className += status ? ` ${status.toLowerCase()}` : ' empty';
      switch (status) {
        case 'Ahead':
          label = locale.getMsg('ahead', [`${offset}`]);
          break;
        case 'OnTime':
          label = locale.getMsg('onTime');
          break;
        case 'Planned':
          label = locale.getMsg('onTime');
          break;
        case 'Behind':
          label = locale.getMsg('late', [`${offset}`]);
          break;
        case 'Complete':
          if (offset > 0) {
            className += '-ahead';
            label = locale.getMsg('ahead', [`${offset}`]);
          }
          if (offset === 0) {
            className += '-ontime';
            label = locale.getMsg('onTime');
          }
          if (offset < 0) {
            className += '-behind';
            label = locale.getMsg('late', [`${-1 * offset}`]);
          }
          break;
        default:
          break;
      }
    }

    return <div className={className}>{label}</div>;
  };

  offline = () => {
    const { selectedDate, clinician } = this.props;
    const { heartbeatTime } = clinician;
    const heartbeatDate = moment(heartbeatTime);
    const nowAt = globals.now;

    if (!nowAt.isSame(parseDateUtc(selectedDate), 'day')) {
      return <span />;
    }

    const { clinicianHeartbeatDuration } = globals.consts;
    const ago = moment.duration(heartbeatDate.diff(nowAt));
    let className = 'state';
    let title = locale.getMsg('noInformation');

    // check if clinican was active twice heartbeat duration
    if (-ago.asMilliseconds() > clinicianHeartbeatDuration * 2 || heartbeatTime === null) {
      className += ' offline';
      if (heartbeatTime) {
        title = locale.getMsg('lastOnline', [ago.humanize(true)]);
      }
    } else {
      title = locale.getMsg('online');
    }

    return <span className={className} title={title} />;
  };

  handleDownloadPlan = event => {
    const { downloadPlan, clinician, selectedDate, jwtToken } = this.props;
    event.preventDefault();
    event.stopPropagation();

    downloadPlan(clinician.id, selectedDate, jwtToken, clinician.clinicianFullName);
  };

  render() {
    const {
      clinician,
      grade,
      canDrop,
      ragCapacity,
      mapViewState,
      workingTime,
      availableTime,
      assignedTime,
      appSettings,
    } = this.props;
    const { isOpen, anchorEl } = this.state;
    const time = data => (
      <span>
        <span className="stat">{data.hours}</span>
        <span className="stat-type">{locale.getMsg('hour')} </span>
        <span className="stat">{data.minutes}</span>
        <span className="stat-type">{locale.getMsg('minute')}</span>
      </span>
    );
    let className = 'list-item clinician';

    const isSelectedInMapView = mapViewState && this.props.selectedClinicianId === clinician.id;
    if (canDrop) {
      className += ' has-skills';
    }

    let isWithinMileageCap = true;
    const clinicianMilegeCap = clinician.mileageCap !== null ? clinician.mileageCap : globals.consts.defaultMileageCap;

    if (item !== null && clinician.hasValidBasePostCode && this.props.postcodeDistance.postcode !== null) {
      isWithinMileageCap = this.props.postcodeDistance.mileages[clinician.basePostCode] <= clinicianMilegeCap;
    }

    if (canDrop && !isWithinMileageCap) {
      className += ' has-warning';
    }
    if (isOpen || isSelectedInMapView) {
      className += ' active';
    }

    const clinicianStatsPopoverContent = (
      <div style={styles.statsPopoverContent} className="popoverContent">
        <span className="popover-title">{clinician.clinicianFullName}</span>
        {clinician.hasValidBasePostCode && (
          <div>
            <div className="work-time-wrapper" style={styles.workingTime}>
              <span className="title-sub">{locale.getMsg('mileageCap')}</span>
              <span>
                <span className="stat">{clinician.mileageCap || globals.consts.defaultMileageCap}</span>
                <span className="stat-type">{locale.getMsg('miles')} </span>
                <span>{`(${clinician.basePostCode})`}</span>
              </span>
            </div>
          </div>
        )}
        <span className="title-sub">{locale.getMsg('hoursSummary')}</span>
        <div style={styles.workingTime}>
          {time(workingTime)}
          <div className="stat-label">{locale.getMsg('totalWorkTime')}</div>
        </div>
        <div style={styles.leftInfoBox}>
          <span className="stat-box left">
            {time(availableTime)}
            <div className="stat-label">{locale.getMsg('available')}</div>
          </span>
          <span className="stat-box right">
            {time(assignedTime)}
            <div className="stat-label">{locale.getMsg('assigned')}</div>
          </span>
        </div>
      </div>
    );
    createCSSSelector(`.clinician-color-${clinician.clinicianColor}`, `color:#${clinician.clinicianColor}!important;`);
    const ragCapacityStyle = `rag ${(ragCapacity > appSettings[RAGSTATUS_RED_FROMINTERVAL] && 'red') ||
      (ragCapacity > appSettings[RAGSTATUS_AMBER_FROMINTERVAL] && 'amber') ||
      'green'}`;
    return (
      <li className={className} role={'presentation'} onClick={this.handleTouchTap}>
        <div className={ragCapacityStyle} />
        <div className="clinician-content">
          <h2 className="clinician-name" title={clinician.clinicianFullName}>
            {this.offline()}
            {clinician.clinicianFullName}
            <IconButton
              className="print-button"
              iconClassName="allocateIcons"
              disableTouchRipple
              onClick={this.handleDownloadPlan}
              title={printMsg}
            >
              print
            </IconButton>
            {clinician.hasValidBasePostCode && (
              <IconButton className="track-changes-button" iconClassName="allocateIcons" disableTouchRipple>
                track_changes
              </IconButton>
            )}
          </h2>
          <div style={this.getViewStyles()} />
          <div className="clinician-subtitle">{grade ? grade.name : ''}</div>
          {this.status()}
          <div className="clinician-has-skills">{hasSkills}</div>
        </div>
        <Popover
          open={isOpen}
          anchorEl={anchorEl}
          anchorOrigin={styles.anchorOrigin}
          targetOrigin={styles.targetOrigin}
          onRequestClose={this.handleRequestClose}
          autoCloseWhenOffScreen
          className="pop-over"
        >
          {clinicianStatsPopoverContent}
        </Popover>
      </li>
    );
  }
}

ClinicianHeader.defaultProps = {
  offset: null,
  status: null,
  differentOrder: false,
  selectedDate: '',
  selectedClinicianId: null,
};

ClinicianHeader.propTypes = {
  canDrop: PropTypes.bool.isRequired,
  grade: gradePropTypes.isRequired,
  clinician: clinicianPropTypes.isRequired,
  workingTime: timePropTypes.isRequired,
  availableTime: timePropTypes.isRequired,
  assignedTime: timePropTypes.isRequired,
  ragCapacity: PropTypes.number.isRequired,
  appSettings: appSettingsPropTypes.isRequired,
  status: PropTypes.string,
  offset: PropTypes.number,
  differentOrder: PropTypes.bool,
  mapViewState: PropTypes.bool.isRequired,
  selectClinician: PropTypes.func.isRequired,
  selectedClinicianId: PropTypes.number,
  postcodeDistance: postcodeMileagesTypes.isRequired,
  selectedDate: PropTypes.string,
  downloadPlan: PropTypes.func.isRequired,
  jwtToken: PropTypes.string.isRequired,
};

export default DropTarget([TREATMENTINSTANCE, ASSIGNMENT], dropTarget, collect)(ClinicianHeader);
